import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/vercel/path0/apps/sdkode/src/components/home/hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.1.6_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/image-component.js");
